export const EMPTY_WIDGET_TYPE_ID = 'EmptyWidget';
